import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    DialogService,
    FileexplorerComponent,
    generateOneSegmentSlug,
    MAT_ICON,
    MetaComponent,
    MetaService,
    TinyMCEHtmlEditorComponent,
    TOAST_STATE,
    ToastmessageService,
    TranslationPipe,
    TranslationService
} from '@prekog/common-ui';
import { map, Observable, switchMap } from 'rxjs';
import { Doctor } from '../../doctors/doctor';
import { GetDoctorResponse } from '../../doctors/getdoctorresponse';
import { UploadFileResponse } from '../../doctors/updatedoctor/uploadfileresponse';
import { Examination } from '../../pricelist/examination';
import { SpecialityInformation } from '../../smarty/specialityinformation';
import { Speciality } from '../../specialitypricelist/speciality';
import { AddexaminationDialogComponent } from './addexaminationdialog/addexaminationdialog.component';
import { AddExaminationDialogResult } from './addexaminationdialog/addexaminationdialogresult';
import { AddSpecialityRequest } from './addspecialityrequest';
import { DoctorWithChecked } from './doctorwithchecked';
import { GetSpecialityTypesResponse } from './getspecialitytypesresponse';
import { SpecialityType } from './specialitytype';

@Component({
    selector: 'app-addspeciality',
    templateUrl: './addspeciality.component.html',
    styleUrls: ['./addspeciality.component.scss'],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatIconModule,
        CommonModule,
        RouterModule,
        MatCheckboxModule,
        MatRadioModule,
        FileexplorerComponent,
        TinyMCEHtmlEditorComponent,
        MetaComponent,
        FormsModule,
        MetaComponent,
        TranslationPipe
    ]
})
export class AddspecialityComponent implements OnInit {
    addSpecialityUrl = '/admin/add-speciality';

    doctorList: Doctor[] = [];

    doctors: DoctorWithChecked[] = [];

    downloadUri = '';

    errorMessageCover = 'Kérem válassza ki az orvoshoz tartozó képeket!';

    examinationList: Examination[] = [];

    fileBaseUrl = '';

    fileCover: File | null = null;

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;

    getDoctorsUrl = '/regenero/get-doctors';

    getSpecialityTypesUrl = '/admin/get-speciality-types';

    html = '';

    htmlForm?: FormGroup;

    id = 0;

    maxFileSize = 5000000;

    regeneroBaseUrl = '';

    slugManuallyEdited = false;
    smartyForm?: FormGroup;

    speciality: Speciality = {};

    specialityForm?: FormGroup;

    specialityInformation?: SpecialityInformation;

    specialityPiece = '';
    specialityTypeId?: number;
    specialityTypeList: SpecialityType[] = [];
    specialityTypeName = '';
    uploadCoverFile = false;
    uploadFileUrl = '/admin/uploadFile';
    specialityUrlPrefix = '/consultation';
    private _metaService = inject(MetaService);

    get isFormValid(): boolean {
        return !!this.specialityForm?.valid && !!this.htmlForm?.valid;
    }
    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        private _translateService: TranslationService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.createSpecialityForm();
        this.createHtmlForm();
        this.createSmartyForm();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.getDoctors();
        }
    }

    createSpecialityForm(): void {
        this.specialityForm = this._fb.group({
            name: ['', [Validators.required]],
            jobTitle: ['', [Validators.required]],
            routerLink: ['', [Validators.required]]
        });
    }

    createHtmlForm(): void {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]]
        });
    }

    createSmartyForm(): void {
        this.smartyForm = this._fb.group({
            specialityInformationName: ['', [Validators.required]]
        });
    }

    collectSmartyData(): void {
        this.specialityInformation = {
            name: this.smartyForm?.controls['specialityInformationName'].value as string | undefined,
            smartyText: this.htmlForm?.controls['html'].value as string | undefined
        };
    }

    collectSpecialityData(downloadUri: string): void {
        const specialityType: SpecialityType = this.specialityTypeList.filter(
            (specialityType) => specialityType.name === this.specialityTypeName
        )[0];
        const name = (this.specialityForm?.controls['name'].value as string) ?? '';
        let slug = ((this.specialityForm?.controls['routerLink'].value as string) ?? '').trim();
        if (!slug) {
            slug = generateOneSegmentSlug(name);
        }
        this.speciality = {
            name: this.specialityForm?.controls['name'].value as string | undefined,
            jobTitle: this.specialityForm?.controls['jobTitle'].value as string | undefined,
            routerLink: slug,
            description: this.htmlForm?.controls['html'].value as string | undefined,
            isSpeciality: true,
            specialityType: specialityType,
            imageUrl: downloadUri
        };

        this.doctors.forEach((doctor) => {
            if (doctor.checked) {
                this.doctorList.push(doctor.doctor!);
            }
        });
    }
    addSpeciality(): void {
        if (!this.uploadCoverFile) {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, this.errorMessageCover, MAT_ICON.warning);
            this._dismissError();
            return;
        }

        if (this.fileCover?.size! > this.maxFileSize) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('file.maxSize'),
                MAT_ICON.error
            );
            this._dismissError();
            return;
        }

        if (this.examinationList.length === 0) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem adjon hozzá tételt a szakrendeléshez!',
                MAT_ICON.warning
            );
            this._dismissError();
            return;
        }

        this.uploadSpecialityImage()
            .pipe(
                switchMap((downloadUri: string) => {
                    this.speciality.imageUrl = downloadUri;
                    return this.addSpecialityPart(downloadUri);
                })
            )
            .subscribe(() => {
                if (this._metaService.canSaveMeta(false)) {
                    this._metaService.saveMetaTag(false, this.specialityForm?.controls['routerLink'].value, this.speciality.imageUrl!);
                }
                this._router.navigateByUrl('/specialities');
            });
    }
    uploadSpecialityImage(): Observable<string> {
        return this._apiRequestService.uploadFile(this.fileCover!, true, this.fileBaseUrl, this.uploadFileUrl).pipe(
            map((uploadFileResponse: any) => {
                const fileCoverResponse = uploadFileResponse as UploadFileResponse;
                return fileCoverResponse.downloadUri as string;
            })
        );
    }
    addSpecialityPart(downloadUri: string): Observable<HttpResponse<any>> {
        this.collectSpecialityData(downloadUri);
        this.examinationList.forEach((examination, index) => {
            examination.orderNumber = index;
        });

        const addSpecialityRequest: AddSpecialityRequest = {
            speciality: this.speciality,
            doctorList: this.doctorList,
            examinationList: this.examinationList
        };

        return this._apiRequestService.sendRequest<AddSpecialityRequest, HttpResponse<any>>(
            this.regeneroBaseUrl,
            addSpecialityRequest,
            true,
            this.addSpecialityUrl,
            true
        );
    }
    changeDoctor(doctorWithChecked: DoctorWithChecked): void {
        this.doctors?.forEach((doctor) => {
            if (doctorWithChecked.doctor?.name === doctor.doctor?.name) {
                doctor.checked = !doctor.checked;
            }
        });
    }
    getSpecialityTypes(): void {
        this._apiRequestService
            .sendRequest<{}, GetSpecialityTypesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialityTypesUrl)
            .subscribe((response) => {
                this.specialityTypeList = response.specialityTypeList as SpecialityType[];
                this.specialityTypeName = this.specialityTypeList[0].name!;
            });
    }
    getDoctors(): void {
        this._apiRequestService
            .sendRequest<{}, GetDoctorResponse>(this.regeneroBaseUrl, {}, true, this.getDoctorsUrl)
            .subscribe((response) => {
                const doctorList = response.doctors as Doctor[];
                const doctorWithCheckedList: DoctorWithChecked[] = [];
                doctorList.forEach((doctor) => {
                    const doctorWithChecked: DoctorWithChecked = {
                        doctor: doctor,
                        checked: false
                    };
                    doctorWithCheckedList.push(doctorWithChecked);
                });
                this.doctors = [...doctorWithCheckedList];

                this.getSpecialityTypes();
            });
    }
    openAddExaminationDialog(): void {
        this._dialogService
            .openDialog(
                AddexaminationDialogComponent,
                null,
                ((addExaminationDialogResult: AddExaminationDialogResult | undefined) => {
                    this.examinationList = [...this.examinationList, addExaminationDialogResult?.examination!];
                }
                )
            )
    }
    removeExamination(index: number): void {
        this.examinationList.splice(index, 1);
    }
    clearSelectedCoverFile(): void {
        this.fileCoverInput.nativeElement.value = null;
        this.uploadCoverFile = false;
    }
    onChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            this.uploadCoverFile = true;
        } else {
            this.uploadCoverFile = false;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem ".jpg" vagy ".png" kiterjesztésű fájlt töltsön fel!',
                MAT_ICON.warning
            );
            this._dismissError();
        }
    }
    onNameBlur(): void {
        const slugControl = this.specialityForm?.controls['routerLink'];
        if (!slugControl || this.slugManuallyEdited) return; // don't overwrite manual entry
        const name = this.specialityForm?.controls['name'].value ?? '';
        if (name) {
            slugControl.setValue(generateOneSegmentSlug(name));
        }
    }
    onSlugInput(): void {
        const slugControl = this.specialityForm?.controls['routerLink'];
        if (!slugControl) return;
        const value = (slugControl.value as string) ?? '';
        if (value.trim() === '') {
            this.slugManuallyEdited = false;
            const name = this.specialityForm?.controls['name'].value ?? '';
            if (name) {
                slugControl.setValue(generateOneSegmentSlug(name));
            }
        } else {
            this.slugManuallyEdited = true;
        }
    }
    shouldShowError(controlName: string): boolean {
        const control = this.specialityForm?.controls[controlName];
        return !!control?.invalid && (!!control?.dirty || !!control?.touched);
    }
    private _dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
